/* eslint-disable no-unused-vars */
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/functions";
let type = location.host.startsWith("elcheapoapp") ? "live" : "staging";
var live = {
  apiKey: "AIzaSyC_jMlA0Uia-d0wgSaEhqN_VuIJ8TzhhpE",
  authDomain: "elcheapoapp.web.app",
  databaseURL: "https://elcheapoapp.firebaseio.com",
  projectId: "elcheapoapp",
  storageBucket: "elcheapoapp.appspot.com",
  dynamicLink: "https://elcheapo.page.link",
  messagingSenderId: "235522402216",
  vapidKey:
    "BEBBaUP87qSgGN1BaV_jFekrOBPG6jo8HVZi4J4V3vtZ6mchSpT4niULLofggqTQ1Iqn-1v7f51jsuc2KQnPj44",
  appId: "1:235522402216:web:f9b3820e375d8478919f9d",
  measurementId: "G-QL6RBY22F5",
};

var staging = {
  apiKey: "AIzaSyAN9U38QlFJaY8BNGOyUDuByFoh08Kulzc",
  authDomain: "staging-elcheapoapp.web.app",
  databaseURL: "https://el-cheapo-staging-default-rtdb.firebaseio.com",
  projectId: "el-cheapo-staging",
  vapidKey:
    "BCDxQ9W5G3t3lGaA4HJG3QlEYmso5FpeHoJ53HXz0-UbzB7f5rn090kssqjAd_z0vAQyAj8M5S7BIK_CHAuryIM",
  storageBucket: "el-cheapo-staging.appspot.com",
  messagingSenderId: "324581383057",
  dynamicLink: "https://elstaging.page.link",
  appId: "1:324581383057:web:be81e68fc54d1cdf8c1830",
};

let firebaseConfig = type == "staging" ? staging : live;

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const fs = firebase.firestore();
const db = firebase.database().ref();
const functions = firebase.functions();
const templates = fs.collection("templates");
const fields = fs.collection("fields");
const globalFields = fs.collection("globalFields");
const fieldOrders = fs.collection("fieldOrders");
const calculatedFields = fs.collection("calculatedFields");
const serviceFields = fs.collection("globalFields");
const fieldConditions = fs.collection("fieldConditions");
const customers = fs.collection("customers");
const scans = fs.collection("scans"); // to get the scannr app's scanned data.
const dispatch = fs.collection("dispatch");
const users = fs.collection("users");
const notifications = fs.collection("notifications");
const user = db.child("users");
const rooms = db.child("rooms");
const technician_rooms = db.child("rooms");
const carMake = fs.collection("carMake");
const carMakeUnlocking = fs.collection("carMakeUnlocking");
const appLogs = fs.collection("appLogs");
const errorLogs = fs.collection("errorLogs");
const modelDataEntryLogs = fs.collection("modelDataEntryLogs");
const technicians = fs.collection("technicians");
const chat_list = fs.collection("chat_list");
const technicianGroups = fs.collection("technicianGroups");
const zipcodes = fs.collection("zipcodes");
const dispositions = fs.collection("dispositions");
const cmp = fs.collection("cmp");
const smsTemplates = fs.collection("smsTemplates");
const appSetting = fs.collection("appSetting");
const tempModels = fs.collection("tempModels");
const localUpdates = fs.collection("localUpdates");
const estimate = fs.collection("estimate");
const keyCategoryLogs = fs.collection("keyCategoryLogs");
const keyTypeLogs = fs.collection("keyTypeLogs");
// if (location.hostname == "localhost") {
//   functions.useFunctionsEmulator("http://localhost:5001");
// }
export {
  auth,
  dispositions,
  zipcodes,
  notifications,
  fs,
  functions,
  technicians,
  templates,
  globalFields,
  serviceFields,
  calculatedFields,
  technician_rooms,
  dispatch,
  firebase,
  fields,
  user,
  customers,
  scans,
  carMake,
  carMakeUnlocking,
  appLogs,
  errorLogs,
  modelDataEntryLogs,
  users,
  technicianGroups,
  chat_list,
  rooms,
  fieldOrders,
  smsTemplates,
  firebaseConfig,
  cmp,
  fieldConditions,
  appSetting,
  tempModels,
  localUpdates,
  estimate,
  keyCategoryLogs,
  keyTypeLogs
};
